export default "__VITE_ASSET__Di38NDhP__"